import Typography from '@mui/material/Typography';

type LoadSegmentProps = {
  startPosition: string;
  endPosition: string;
  loadNumber: number;
};

const LoadSegmentNumber = ({
  startPosition,
  endPosition,
  loadNumber,
}: LoadSegmentProps) => {
  return (
    <Typography
      variant={'body2'}
      sx={{
        position: 'absolute',
        left: startPosition,
        right: endPosition,
        textAlign: 'center',
      }}
    >
      {loadNumber}
    </Typography>
  );
};

export { LoadSegmentNumber };
